import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Formik } from 'formik'

import { Form } from 'reactstrap'

import BaseContainer from '../common/BaseContainer'
import ControlHeader from '../common/ControlHeader'
import PrimaryButton from '../common/buttons/PrimaryButton'
import { ModalManagerContext } from '../ModalsManager'
import { SuccessMessage, ErrorMessage, useVisible } from '../common/AlertManager'
import fetch from '../../utils/fetcher'
import useFetch from '../../utils/useFetch'
import generateFormikInputs from '../../utils/generateFormikInputs'

import { formsInputsData, validationSchema } from './config'
import useStyles from './styles'


const url = `${process.env.REACT_APP_API_URL}/legal_text`

const LegalText = () => {
  const { t } = useTranslation(['translation', 'COMMON'])
  const [successMessage, setSuccessMessage] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)
  const { visible: isErrorVisible, open: openError } = useVisible(false)
  const { visible: isSuccessMessageVisible, open: openSuccessMessage } = useVisible(false)
  const openModal = useContext(ModalManagerContext)
  const { render } = useFetch(url, openModal)
  const classes = useStyles();

  const onSubmit = data => {
    const config = {
      headers: { 'content-type': 'application/json' },
      method: 'PATCH',
      body: JSON.stringify(data)
    }

    setIsLoading(prevState => !prevState) // true

    fetch(url, config)
      .then(() => {
        setSuccessMessage(t('COMMON.SUCCESSFUL_UPDATE'))
        openSuccessMessage()
      })
      .catch(e => {
        setError(e)
        openError()
      })
      .finally(() => setIsLoading(prevState => !prevState)) // false
  }

  return (
    <BaseContainer>
      <ControlHeader showTabs title={t('LEGAL_TEXT.TITLE_TAB')} activeTab="legalText" />
      { successMessage && <SuccessMessage message={successMessage} visible={isSuccessMessageVisible} /> }
      <ErrorMessage error={error} visible={isErrorVisible} />
      {render(data => (
        <Formik initialValues={data} onSubmit={onSubmit} validationSchema={validationSchema}>
          {({ handleSubmit, ...formikProps }) => (
            <Form onSubmit={handleSubmit} className={classes.form}>
              {generateFormikInputs(formsInputsData, formikProps, false)}

              <PrimaryButton disabled={isLoading} type="submit" className={classes.button}>
                {t('COMMON.UPDATE_BUTTON')}
              </PrimaryButton>
            </Form>
          )}
        </Formik>
      ))}
    </BaseContainer>
  )
}

export default LegalText
